import { IconName } from "components/atoms/Icon";
import React, { ReactNode } from "react";
import { mapMultiClassnames } from "utils/map-modifier";
import "./index.scss";

interface TextareaFieldProps {
  name: string;
  placeholder?: string;
  modifiers?: Modifiers;
  iconName?: IconName;
  value?: string;
  label?: string;
  validate?: "valid" | "invalid";
  button?: ReactNode;
  autoComplete?: "off";
  refs?: any;
  onChange?: (e: any) => void;
}

const TextareaField: React.FC<TextareaFieldProps> = ({
  name,
  refs,
  iconName,
  label,
  value,
  button,
  modifiers,
  validate,
  onChange,
  ...innerProps
}) => (
  <div
    className={mapMultiClassnames(
      "a-textarea-field",
      modifiers,
      value ? "emty" : "none-emty",
    )}
  >
    <div className="a-textarea-field_inner">
      <textarea
        name={name}
        ref={refs}
        className="a-textarea-field_input"
        {...innerProps}
        rows={3}
        onChange={onChange}
      ></textarea>
      <span className="a-textarea-field_bar"></span>
      {label && <label>{label}</label>}
      {modifiers &&
        (modifiers.includes("valid") || modifiers.includes("invalid")) && (
          <span className="a-textarea-field-valid_icon"></span>
        )}
      {button && <div className="a-textfield_button">{button}</div>}
    </div>
  </div>
);

TextareaField.defaultProps = {};

export default TextareaField;
